<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JI6YAz/tc-custom/9780830870837.jpg?1696025819956" alt="This image is the cover for the book Barefoot Study Guide, Sensible Shoes Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Barefoot Study Guide, Sensible Shoes Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>The journeys of Hannah, Meg, Charissa, and Mara take unexpected turns in <em>Barefoot</em>, the third book of the Sensible Shoes series.</strong> In this study guide author Sharon Garlough Brown has crafted a practical resource to help you process the characters' stories and explore the novel's spiritual formation themes more deeply. You'll find twelve weeks of daily Scripture readings, reflection questions, and invitations to prayer, with weekly discussion questions and practices for groups to do together. Each week also features a list of spiritual disciplines used by the characters that you can incorporate into your own life with God. Individually or with a group, as you walk with the women of<em>Sensible Shoes</em> on holy ground, you'll be invited to encounter God in significant new ways.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Garlough Brown
      </h2>
      
      <p class="authorDescription body article"><p>Sharon Garlough Brown is a spiritual director, speaker, and cofounder of Abiding Way Ministries, providing spiritual formation retreats and resources. A graduate of Princeton Theological Seminary, Sharon has served on the pastoral staff of congregations in Scotland, Oklahoma, England, and most recently in West Michigan, where she copastored with her husband, Jack, for many years. In March 2013 her book <em>Sensible Shoes</em> was named one of television personality Kathie Lee Gifford's "favorite things."</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4049ff1c